
export class GC_Valid_T_Integer {

    protected min;
    protected max;
    protected exact;

    constructor(opt) {
        this.min        = opt && opt.min || false;
        this.max        = opt && opt.max || false;
        this.exact      = opt && opt.exact || false;
    }

    public validate(variable) {
        let ok = true;
        variable = parseInt(variable + '');
        if (false !== this.min) {
            ok  = ok && variable >= this.min;
        }
        if (false !== this.max) {
            ok  = ok && variable <= this.max;
        }
        if (false !== this.exact) {
            ok  = ok && variable === this.exact;
        }
        return ok;
    }

}
